// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-custom-dialog[data-v-344b4638]{-ms-flex-item-align:end;align-self:flex-end}", ""]);
// Exports
module.exports = exports;
